import React, { useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames              from 'classnames';
// import ListIcon                from '../../assets/icon/ListIcon';
// import AmbulanceIcon           from '../../assets/icon/AmbulanceIcon';
// import ConsultantIcon          from '../../assets/icon/ConsultantIcon';
import useMediaQuery           from '../../hooks/useMediaQuery';
import { useModal }            from '../../utils/useModal';
import { MODALS }              from '../../constants';
import doc1                    from '../../assets/images/doc1.png';
import doc2                    from '../../assets/images/doc2.png';
import doc3                    from '../../assets/images/doc3.png';
import style                   from './CardInfo.module.scss';

function CardInfo() {
    const isDesktop = useMediaQuery('(min-width: 1100px)');
    const isTablet = useMediaQuery('(min-width: 768px)');

    const { toggleModal } = useModal();

    const toggleCatalog = useCallback(({ target }) => {
        const modal = target.closest('button').getAttribute('data-id');
        const getPopup = () => {
            switch (modal) {
                case 'POPUP_CONSULTATION':
                    return MODALS.POPUP_CONSULTATION;
                case 'POPUP_STEP':
                    return MODALS.POPUP_STEP;
                case 'POPUP_DELIVERY_NEW':
                    return MODALS.POPUP_DELIVERY_NEW;
                default:
                    return false;
            }
        };


        if (modal) toggleModal({ id: getPopup() });
    }, []);


    return (
        <section className={style['card-info']}>
            <div className={style.container}>
                <div className={style['card-info__inner']}>
                    {
                        isDesktop ?

                            <div className={style['card-info__wrapper']}>
                                <button
                                    className={style['card-info__card']}
                                    onClick={toggleCatalog}
                                    data-id='POPUP_STEP'
                                >
                                    <div className={style['card-info__img']}>
                                        {/* <ListIcon />*/}
                                        <img
                                            data-src={doc1} className={'lazyload'}
                                            alt='test' />
                                    </div>
                                    <h2>
                                        Замовлення всього списку в одному місці
                                    </h2>
                                </button>

                                <button
                                    onClick={toggleCatalog}
                                    data-id='POPUP_DELIVERY_NEW'
                                    className={classNames(style['card-info__card'], style['not-active'])}
                                >
                                    <div className={style['card-info__img']}>
                                        {/* <AmbulanceIcon />*/}
                                        <img
                                            data-src={doc2} className={'lazyload'}
                                            alt='test' />
                                    </div>
                                    <h2>
                                        Швидка <br /> доставка ліків
                                    </h2>
                                </button>

                                <button
                                    onClick={toggleCatalog}
                                    data-id={'POPUP_CONSULTATION'}
                                    className={style['card-info__card']}>
                                    <div className={style['card-info__img']}>
                                        {/* <ConsultantIcon />*/}
                                        <img
                                            data-src={doc3} className={'lazyload'}
                                            alt='test' />
                                    </div>
                                    <h2>
                                        On-line консультация експерта-фармацевта
                                    </h2>
                                </button>
                            </div>
                            :

                            <Swiper
                                spaceBetween={15}
                                slidesPerView={isTablet ? 2.5 : 1.2}
                                className={style['card-info__wrapper']}
                                loop
                            >
                                <SwiperSlide className={style['swiper-slider']}>
                                    <button
                                        data-id='POPUP_STEP'
                                        onClick={toggleCatalog}
                                        className={classNames(style['card-info__card'], style.one)}
                                    >
                                        <div className={style['card-info__img']}>
                                            {/* <ListIcon />*/}
                                            <img
                                                data-src={doc1} className={'lazyload'}
                                                alt='test' />
                                        </div>
                                        <h2>
                                            Замовлення всього списку в одному місці
                                        </h2>
                                    </button>
                                </SwiperSlide>

                                <SwiperSlide className={style['swiper-slider']}>
                                    <button
                                        onClick={toggleCatalog}
                                        className={classNames(style['card-info__card'], style['not-active'])}
                                        data-id='POPUP_DELIVERY_NEW'
                                    >
                                        <div className={style['card-info__img']}>
                                            {/* <AmbulanceIcon />*/}
                                            <img
                                                data-src={doc2} className={'lazyload'}
                                                alt='test' />
                                        </div>
                                        <h2>
                                            Швидка <br /> доставка ліків
                                        </h2>
                                    </button>
                                </SwiperSlide>

                                <SwiperSlide className={style['swiper-slider']}>
                                    <button
                                        onClick={toggleCatalog}
                                        data-id={'POPUP_CONSULTATION'}
                                        className={classNames(style['card-info__card'], style.three)}
                                    >
                                        <div className={style['card-info__img']}>
                                            {/* <ConsultantIcon />*/}
                                            <img
                                                data-src={doc3} className={'lazyload'}
                                                alt='test' />
                                        </div>
                                        <h2>
                                            On-line консультация експерта-фармацевта
                                        </h2>
                                    </button>
                                </SwiperSlide>
                            </Swiper>
                    }
                </div>
            </div>
        </section>
    );
}

export default React.memo(CardInfo);
